import React, { useState, useEffect } from 'react';
import './ChatAnimation.css';

const ChatAnimation = ({ language = 'en' }) => {
  const [visibleMessages, setVisibleMessages] = useState([]);
  const [showTyping, setShowTyping] = useState({ show: false, sender: null });

  // Conversation messages for each language
  const conversation = {
    en: [
      { sender: 'sahra', text: 'Hi there 😊 How do you feel today?' },
      { sender: 'user', text: 'Today I feel overwhelmed with everything... How can I feel better?' },
      { sender: 'sahra', text: 'I\'m sorry to hear that you\'re feeling overwhelmed today. It\'s completely understandable to have days like this. One strategy that may help is to take a break and do something that brings you joy, like spending time with loved...' }
    ],
    de: [
      { sender: 'sahra', text: 'Hallo 😊 Wie fühlst du dich heute?' },
      { sender: 'user', text: 'Heute fühle ich mich von allem überwältigt... Wie kann ich mich besser fühlen?' },
      { sender: 'sahra', text: 'Es tut mir leid zu hören, dass Sie sich heute überfordert fühlen. Es ist völlig verständlich, solche Tage zu haben. Eine Strategie, die helfen könnte, ist, eine Pause zu machen und etwas zu tun, das Ihnen Freude bereitet, wie Zeit mit geliebten...' }
    ],
    it: [
      { sender: 'sahra', text: 'Ciao 😊 Come ti senti oggi?' },
      { sender: 'user', text: 'Oggi mi sento sopraffatto da tutto... Come posso sentirmi meglio?' },
      { sender: 'sahra', text: 'Mi dispiace sentire che ti senti sopraffatto oggi. È del tutto comprensibile avere giornate così. Una strategia che potrebbe aiutare è prendersi una pausa e fare qualcosa che ti porta gioia, come passare del tempo con i cari...' }
    ],
    ar: [
      { sender: 'sahra', text: 'مرحباً 😊 كيف حالك اليوم؟' },
      { sender: 'user', text: 'اليوم أشعر بالإرهاق من كل شيء... كيف يمكنني أن أشعر بتحسن؟' },
      { sender: 'sahra', text: 'يؤسفني أن أسمع أنك تشعر بالإرهاق اليوم. من الطبيعي تماماً أن تكون لديك أيام كهذه. إحدى الاستراتيجيات التي قد تساعد هي أخذ استراحة والقيام بشيء يجلب لك السعادة، مثل قضاء الوقت مع الأحباء...' }
    ]
  };

  const messages = conversation[language] || conversation.en;

  useEffect(() => {
    let timeouts = [];

    const runAnimation = () => {
      // Reset
      setVisibleMessages([]);
      setShowTyping({ show: false, sender: null });

      // Message 1: Sahra's greeting
      timeouts.push(setTimeout(() => {
        setShowTyping({ show: true, sender: 'sahra' });
      }, 500));

      timeouts.push(setTimeout(() => {
        setShowTyping({ show: false, sender: null });
        setVisibleMessages([messages[0]]);
      }, 2000));

      // Message 2: User's response
      timeouts.push(setTimeout(() => {
        setShowTyping({ show: true, sender: 'user' });
      }, 3000));

      timeouts.push(setTimeout(() => {
        setShowTyping({ show: false, sender: null });
        setVisibleMessages([messages[0], messages[1]]);
      }, 4500));

      // Message 3: Sahra's reply
      timeouts.push(setTimeout(() => {
        setShowTyping({ show: true, sender: 'sahra' });
      }, 5500));

      timeouts.push(setTimeout(() => {
        setShowTyping({ show: false, sender: null });
        setVisibleMessages([messages[0], messages[1], messages[2]]);
      }, 7500));

      // Hold all messages visible for 3 seconds, then restart
      timeouts.push(setTimeout(() => {
        runAnimation();
      }, 11000));
    };

    runAnimation();

    return () => {
      timeouts.forEach(timeout => clearTimeout(timeout));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  return (
    <div className="chat-animation-container">
      <div className="chat-conversation">
        {visibleMessages.map((msg, index) => (
          <div key={index} className={`chat-message-row ${msg.sender}`}>
            {msg.sender === 'sahra' && (
              <img
                src="/favicon-256.png"
                alt="Sahra"
                className="message-avatar"
              />
            )}
            <div className={`message-bubble ${msg.sender}-bubble`} lang={language}>
              {msg.text}
            </div>
            {msg.sender === 'user' && (
              <div className="user-avatar">
                <span className="user-icon">👤</span>
              </div>
            )}
          </div>
        ))}

        {/* Typing indicator */}
        {showTyping.show && (
          <div className={`chat-message-row ${showTyping.sender}`}>
            {showTyping.sender === 'sahra' && (
              <img
                src="/favicon-256.png"
                alt="Sahra"
                className="message-avatar"
              />
            )}
            <div className={`typing-bubble ${showTyping.sender}-bubble`}>
              <div className="typing-indicator">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
            </div>
            {showTyping.sender === 'user' && (
              <div className="user-avatar">
                <span className="user-icon">👤</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatAnimation;
